import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//采购单接口服务
class PurchasePoService {
    //新建采购单
    static async insert(data) {
        const apiUrl = "/purchase/po/insert";
        return await http.post(apiUrl, data);
    }

    //修改采购单
    static async update(data) {
        const apiUrl = "/purchase/po/update";
        return await http.post(apiUrl, data);
    }


    //分页查询采购单信息
    static async findPage(data) {
        const apiUrl = "/purchase/po/findPage";
        return await http.post(apiUrl, data);
    }

    //根据ID查询采购单信息
    static async findByIdOrCode(id) {
        const apiUrl = `/purchase/po/findByIdOrCode/${id}`;
        return await http.get(apiUrl);
    }

    //作废
    static async disable(data) {
        const apiUrl = `/purchase/po/disable/${data}`;
        return await http.get(apiUrl);
    }

    //库房确认
    static async whConfirm(data) {
        const apiUrl = `/purchase/po/whConfirm/${data}`;
        return await http.get(apiUrl);
    }

    //结算
    static async settle(data) {
        const apiUrl = "/purchase/po/settle";
        return await http.post(apiUrl, data);
    }
    //转销售单
    static async shift(data) {
        const apiUrl = "/purchase/po/shift";
        return await http.post(apiUrl, data);
    }
    //导出
    static async exportPo(data) {
        // console.log(data)
        const apiUrl = `/purchase/po/export`;
        await download(apiUrl, {type:"POST",data})
    }

    /********************************************************************/

    //查询采购单明细(采购退货使用)
    static async findDetailPage(data) {
        const apiUrl = `/purchase/po/detail/findDetailPage`;
        return await http.post(apiUrl, data);
    }
    //下载明细导入模板
    static async downloadDetailTpl() {
        const apiUrl = `/purchase/po/detail/downloadTpl`;
        await download(apiUrl,)
    }

    //获取导入配置
    static getImportDetailCfg(cfg) {
        const apiUrl = "/purchase/po/detail/import";
        return uploadCfg(apiUrl, cfg);
    }
}

export default PurchasePoService;
